import { forwardRef } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import './Button.css';

const Spinner = () => (
  <svg className="ds-btn-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeDasharray="42"
      strokeDashoffset="14"
    />
  </svg>
);

const Button = forwardRef(function Button(
  {
    children,
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled = false,
    iconLeft = null,
    iconRight = null,
    className = '',
    type = 'button',
    ...rest
  },
  ref
) {
  const reduceMotion = useReducedMotion();
  const isDisabled = disabled || loading;

  return (
    <motion.button
      ref={ref}
      type={type}
      className={`ds-btn ds-btn-${variant} ds-btn-${size} ${className}`.trim()}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      whileHover={!reduceMotion && !isDisabled ? { y: -1 } : undefined}
      whileTap={!reduceMotion && !isDisabled ? { scale: 0.97, y: 0 } : undefined}
      transition={{ duration: 0.15, ease: [0.4, 0, 0.2, 1] }}
      {...rest}
    >
      {loading ? (
        <Spinner />
      ) : (
        iconLeft && <span className="ds-btn-icon">{iconLeft}</span>
      )}
      <span className="ds-btn-label">{children}</span>
      {!loading && iconRight && <span className="ds-btn-icon">{iconRight}</span>}
    </motion.button>
  );
});

export default Button;
